import React from "react";

import DietKindForm from "../components/DietKindForm";

const NewDietKind = () => {
  return <DietKindForm />;
};

export default NewDietKind;
